import axios from 'axios';
import keycloak from '../common/Keycloak';
import CryptoJS from 'crypto-js';
import alertifyjs from 'alertifyjs';

function isReversePickAcknowledgmentPage() {
  const routePath = window.location.hash.replace(/^#/, '') || window.location.pathname;
  return routePath.startsWith('/ReversePickAcknowledgment');
}

export default function setup() {
  const lmuMetaAllowedOrigins = new Set([
    'https://lastmileallocationpod-api.xbees.in',
    'https://lastmileallocationpod-apistage.xbees.in',
    'http://localhost:3800'
  ]);

  if (keycloak.enableKavach) {
    axios.interceptors.request.use(function (config) {
      
      let userToken = window.localStorage.getItem('lmUserToken')
      let token = userToken ? userToken.replace(/"/g, '') : false;
      if (token && !config.headers.Authorization) {
        config.headers['x-auth-type'] = `lm-kavach-web`;
        config.headers.Authorization = `Bearer ${token}`;
        
        let userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        let userDataKey = window.localStorage.getItem('userUniqueKey')
        if(userdetailEncrypt && userDataKey)
        {
          let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), userDataKey);
          let plaintext = bytes.toString(CryptoJS.enc.Utf8);
          let userdetail = JSON.parse(plaintext);
          config.headers['id'] = userdetail.userid;
          let requestOrigin = '';
          try {
            requestOrigin = new URL(config.url || '').origin;
          } catch (e) {
            requestOrigin = '';
          }
          let isLmuMetaAllowed = lmuMetaAllowedOrigins.has(requestOrigin);
          if (isLmuMetaAllowed && userdetail.hubdetails && userdetail.hubdetails[0] != null) {
            config.headers['x-lmu-meta-01'] = userdetail.hubdetails[0].toString()
          }
        }
      } else if (!isReversePickAcknowledgmentPage()) {
        alertifyjs.error('Unauthorized access. Please login again.');
        keycloak.logoutWithTokenId();
      }

      

      return config;
    }, function (err) {
      return Promise.reject(err);
    });

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      return response;
    },function (error) {
      let isLoggedIn = window.localStorage.getItem('isLoggedIn');
      if (error && error.response && error.response.status === 401) {
        let errorRes = ((error.response && error.response.data) ? error.response.data : {});
        // this.$alertify.error(errorRes.message);
       
        if (!isReversePickAcknowledgmentPage()) {
          if(isLoggedIn){
            alertifyjs.error(errorRes.message);
          }
          window.localStorage.setItem('isLoggedIn',false);
          keycloak.logoutWithTokenId();
        }
      } else {
        return Promise.reject(error);
      }
    });
  }
  return;
};


// WEBPACK FOOTER //
// ./src/common/requestInterceptor.js